document.addEventListener("DOMContentLoaded", function () {
  const validDiscounts = {
    "DANKEFUNKE": { label: "10%" },
    "SOMMER2025": { label: "20%" },
    "VIP10": { label: "10% exklusiv" }
  };

  const discount = getCookie("discount_code");
  const dismissed = localStorage.getItem("discount_popup_dismissed");
  const codeData = discount ? validDiscounts[discount.toUpperCase()] : null;

  if (codeData && !dismissed) {
    showDiscountPopup(discount.toUpperCase(), codeData);
  }

  function showDiscountPopup(code, data) {
    const popup = document.createElement("div");
    popup.className = "discount-popup-overlay";
    popup.innerHTML = `
      <div class="discount-popup-box">
        <h3>Dein ${data.label} Rabatt wartet 🎉</h3>
        <div class="discount-code-box">${code}</div>
        <p>Nutze diesen Code und dein Rabatt wird automatisch im Checkout angewendet.</p>
        <button id="close-discount-popup">🎁 ${data.label} Rabatt nehmen!</button>
      </div>
    `;

    const style = document.createElement("style");
    style.innerHTML = `
      .discount-popup-overlay {
        position: fixed;
        top: 0; left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
      }

      .discount-popup-box {
        background-color: #fff;
        color: #80A594;
        border-radius: 12px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
        text-align: center;
        padding: 32px 24px;
        width: 90%;
        max-width: 600px; /* DEUTLICH GRÖSSER AUF DESKTOP */
        font-family: sans-serif;
      }

      @media (min-width: 768px) {
        .discount-popup-box {
          width: 36vw; /* ca. 1/3 vom Bildschirm */
          max-width: none;
        }
      }

      .discount-popup-box h3 {
        font-size: 2.6rem;
        margin-bottom: 16px;
      }

      .discount-popup-box p {
        margin: 16px 0;
        font-size: 1.5rem;
      }

      .discount-code-box {
        border: 2px dashed #80A594;
        padding: 14px 24px;
        margin: 12px 0;
        font-size: 2.2rem;
        font-weight: bold;
        display: inline-block;
        border-radius: 6px;
        letter-spacing: 1px;
      }

      #close-discount-popup {
        background-color: #C1DACE;
        color: #000;
        font-weight: bold;
        padding: 14px 28px;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        font-size: 1.5rem;
        margin-top: 10px;
        transition: all 0.3s ease;
        width: 100%;
        max-width: 280px;
      }

      #close-discount-popup:hover {
        background-color: #aed5c1;
      }
    `;
    document.head.appendChild(style);
    document.body.appendChild(popup);

    document.getElementById("close-discount-popup").addEventListener("click", function () {
      localStorage.setItem("discount_popup_dismissed", "true");
      popup.remove();
    });
  }

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }
});
